import { render, staticRenderFns, recyclableRender, components } from "./Mpservice.vue?vue&type=template&id=2afbbfec&"
var renderjs
import script from "./Mpservice.vue?vue&type=script&lang=js&"
export * from "./Mpservice.vue?vue&type=script&lang=js&"
import style0 from "./Mpservice.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!E:\\HBuilderX\\plugins\\uniapp-cli\\node_modules\\@dcloudio\\vue-cli-plugin-uni\\packages\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null,
  false,
  components,
  renderjs
)

component.options.__file = "components/mpservice/Mpservice.vue"
export default component.exports